<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <!-- 不缓存的页面，不缓存$route.meta.keepAlive为false的组件 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- 当页面滚动超过 30px 时显示"返回顶部"按钮 -->
    <el-backtop target="#app" :visibility-height="30"></el-backtop>
  </div>
</template>

<script>
import {backTop} from '@/bus.js'
// 每次路由切换时，自动调用返回顶部函数
export default {
  name: 'App',
  watch:{
    $route:function(){
      backTop();
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  margin: 0;
  padding: 0;
  /* padding-bottom: 60px; */
  /* display: flex; */
  /* justify-content: center; */
  /* text-align: center;
   */
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue